'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reactScroll = require('react-scroll');
var _reactIntlTelInput = require('react-intl-tel-input');var _reactIntlTelInput2 = _interopRequireDefault(_reactIntlTelInput);

var _ProjectCommodities = require('./ProjectCommodities');var _ProjectCommodities2 = _interopRequireDefault(_ProjectCommodities);
var _ProjectPerformers = require('./ProjectPerformers');var _ProjectPerformers2 = _interopRequireDefault(_ProjectPerformers);
var _ProjectAdvantages = require('./ProjectAdvantages');var _ProjectAdvantages2 = _interopRequireDefault(_ProjectAdvantages);
var _ProjectInformation = require('./ProjectInformation');var _ProjectInformation2 = _interopRequireDefault(_ProjectInformation);

var _components = require('../../components');

var _constants = require('./constants');
var _constants2 = require('../../constants');

var _PublishNewHomesForm = require('./PublishNewHomesForm.scss');var styles = _interopRequireWildcard(_PublishNewHomesForm);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

ProjectDetails = function (_Component) {_inherits(ProjectDetails, _Component);function ProjectDetails() {var _temp, _this, _ret;_classCallCheck(this, ProjectDetails);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      isChangeImg: false }, _this.


    changeImages = function (data) {
      var publicId = null;
      var full = null;
      var image = data.length ? data[0] : {};

      if (data.length) {
        publicId = image.public_id ? image.public_id : image.full && image.full.split('/').pop();
        full = image.full;
      }

      var userImage = {
        link: publicId,
        angle: image.angle || 0,
        full: full };


      _this.setState({ isChangeImg: true });
      _this.props.changeValue('project_img', userImage);
    }, _this.

    uploadWidget = function (_ref) {var meta = _ref.meta;return (
        _react2.default.createElement('div', { className: styles.widget },
          _react2.default.createElement(_components.UploadAssetWidget, {
            openMessageModal: _this.props.openMessageModal,
            className: (0, _classnames2.default)({ 'has-error-form': !!meta.error && meta.touched }),
            translate: _this.props.translate('uploadWidget'),
            rootTranslate: _this.props.translate,
            isMobile: _this.props.isMobile,
            initialImages: _this.fetchInitialProfileImageValue(),
            uploadInProgress: function uploadInProgress(status) {return _this.setState({ uploadPhotoInProgress: status });},
            updateContent: _this.changeImages,
            contentUploaded: _this.changeImages,
            markAssetToDelete: _this.props.addAssetToDelete,
            suspendedUpload: true,
            userToken: _this.props.token })));}, _this.




    handleSelectFlag = function (value, flag) {return (
        _this.props.onPhoneChange(null, value || _this.props.phoneNumber, flag));}, _this.

    fetchInitialProfileImageValue = function () {
      var profileImage = (0, _get2.default)(_this.props, 'initialValues.project_img', null) ||
      (0, _get2.default)(_this.props, 'fields.project_img.full', null);

      if (!profileImage) return [];

      var angle = _components.UploadAssetWidget.getAngle({ full: profileImage });
      var linkId = profileImage && profileImage.split('/').pop();

      var value = profileImage ? [{
        full: profileImage,
        thumbnail: profileImage,
        _id: linkId,
        angle: angle,
        relativeAngle: 0 }] :
      [];

      if (!_this.state.isChangeImg) {
        _this.changeImages(value);
      }

      return value;
    }, _this.

    renderInput = function (input, meta, placeholder) {var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'text';return (
        _react2.default.createElement('input', _extends({},
        input, {
          type: type,
          placeholder: _this.props.translate('addNewProject', placeholder),
          className: (0, _classnames2.default)(styles.inputNumb, styles.numeric, 'form-control',
          { not_valid: meta.touched && meta.error && !meta.active }) })));}, _this.



    renderPhoneNumber = function (_ref2) {var input = _ref2.input,phoneNumber = _ref2.phoneNumber,_ref2$meta = _ref2.meta,error = _ref2$meta.error,touched = _ref2$meta.touched;return (
        _react2.default.createElement('div', { className: styles.phoneNumber },
          _react2.default.createElement(_reactIntlTelInput2.default, {
            autoPlaceholder: false,
            containerClassName: 'intl-tel-input',
            fieldName: input.name,
            placeholder: _this.props.translate('editOwner', 'phone_number'),
            value: phoneNumber,
            inputClassName: 'form-control phone-input',
            preferredCountries: _constants2.PREFERRED_COUNTRIES,
            onPhoneNumberChange: _this.props.onPhoneChange,
            onSelectFlag: _this.handleSelectFlag,
            useMobileFullscreenDropdown: false,
            separateDialCode: true,
            nationalMode: false }),

          !!error && touched &&
          _react2.default.createElement('span', { className: styles.required },
            _this.props.translate('errorFieldMessages', 'phone-number'))));}, _this.






    renderUploadWidget = function () {return (
        _react2.default.createElement(_reactScroll.Element, { name: _constants.PROJECT_FIELDS_NAMES.project_img, className: styles.uploadWidget },
          _react2.default.createElement('div', { className: styles.widgetLabel },
            _this.props.translate('addNewProject', 'projectLogo'),
            _react2.default.createElement('span', { className: 'req' }, '*')),

          _react2.default.createElement(_reduxForm.Field, {
            name: _constants.PROJECT_FIELDS_NAMES.project_img,
            locale: _this.props.locale,
            component: _this.uploadWidget })));}, _temp), _possibleConstructorReturn(_this, _ret);}ProjectDetails.prototype.




  render = function render() {var _props =

















    this.props,translate = _props.translate,fields = _props.fields,push = _props.push,remove = _props.remove,locale = _props.locale,isMobile = _props.isMobile,token = _props.token,addAssetToDelete = _props.addAssetToDelete,isRtl = _props.isRtl,changeValue = _props.changeValue,initialValues = _props.initialValues,openMessageModal = _props.openMessageModal,replaceAt = _props.replaceAt,phoneNumber = _props.phoneNumber,isForeign = _props.isForeign,loading = _props.loading;

    return (
      _react2.default.createElement('div', null,
        _react2.default.createElement('div', { className: styles.title },
          _react2.default.createElement('p', null, this.props.translate('addNewProject', 'projectDetailsTitle'))),

        this.renderUploadWidget(),
        _react2.default.createElement(_reactScroll.Element, {
            name: _constants.PROJECT_FIELDS_NAMES.phone_number,
            className: (0, _classnames2.default)(styles.requiredFieldWrapper, styles.phoneSection) },

          _react2.default.createElement('div', { className: styles.label }, translate('editOwner', 'phone_number'), _react2.default.createElement('span', { className: 'req' }, '*')),
          _react2.default.createElement('div', { className: 'fieldset' },
            !loading &&
            _react2.default.createElement(_reduxForm.Field, {
              name: _constants.PROJECT_FIELDS_NAMES.phone_number,
              isRtl: isRtl,
              translate: translate,
              locale: locale,
              label: '' + translate('editOwner', 'phone_number'),
              component: this.renderPhoneNumber,
              required: true,
              props: { phoneNumber: phoneNumber } }))),




        _react2.default.createElement(_ProjectCommodities2.default, _extends({
          translate: translate,
          fields: fields,
          push: push,
          remove: remove,
          name: _constants.PROJECT_FIELDS_NAMES.commodities,
          changeValue: changeValue,
          replaceAt: replaceAt,
          isMobile: isMobile,
          isRtl: isRtl },
        this.props)),

        _react2.default.createElement(_ProjectAdvantages2.default, _extends({
          translate: translate,
          fields: fields,
          isForeign: isForeign,
          locale: locale,
          push: push,
          remove: remove,
          name: _constants.PROJECT_FIELDS_NAMES.advantages,
          isMobile: isMobile,
          isRtl: isRtl },
        this.props)),

        _react2.default.createElement(_ProjectInformation2.default, _extends({
          translate: translate,
          fields: fields,
          name: _constants.PROJECT_FIELDS_NAMES.buildings,
          isMobile: isMobile,
          isRtl: isRtl },
        this.props)),

        _react2.default.createElement(_ProjectInformation2.default, _extends({
          translate: translate,
          fields: fields,
          name: _constants.PROJECT_FIELDS_NAMES.apartments,
          isMobile: isMobile,
          isRtl: isRtl },
        this.props)),

        _react2.default.createElement(_ProjectInformation2.default, _extends({
          translate: translate,
          fields: fields,
          name: _constants.PROJECT_FIELDS_NAMES.floors,
          isMobile: isMobile,
          isRtl: isRtl },
        this.props)),

        _react2.default.createElement(_ProjectPerformers2.default, {
          openMessageModal: openMessageModal,
          translate: translate,
          locale: locale,
          fields: fields,
          isMobile: isMobile,
          token: token,
          addAssetToDelete: addAssetToDelete,
          isRtl: isRtl,
          changeValue: changeValue,
          initialValues: initialValues })));



  };return ProjectDetails;}(_react.Component);exports.default = ProjectDetails;


ProjectDetails.propTypes = {
  translate: _propTypes2.default.func,
  fields: _propTypes2.default.object,
  push: _propTypes2.default.func,
  remove: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  isForeign: _propTypes2.default.bool,
  token: _propTypes2.default.string,
  addAssetToDelete: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  changeValue: _propTypes2.default.func,
  initialValues: _propTypes2.default.object,
  openMessageModal: _propTypes2.default.func,
  replaceAt: _propTypes2.default.func,
  onPhoneChange: _propTypes2.default.func,
  phoneNumber: _propTypes2.default.string,
  loading: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishNewHomesForm/ProjectDetails.js
// module id = 3054
// module chunks = 0